import { shouldRetryCriosCommit } from '~/lib/utils/crios-commit-retry'

// Buffer after hydration before reloading, so the retried commit lands well past
// the tab-opening animation the original commit raced (the cause of the bug —
// see shouldRetryCriosCommit).
const STORAGE_KEY = 'crios-commit-retried'

export default defineNuxtPlugin((nuxtApp) => {
  const route = useRoute()

  nuxtApp.hook('app:mounted', () => {
    const shouldRetry = shouldRetryCriosCommit({
      userAgent: navigator.userAgent,
      navigationType: performance.getEntriesByType('navigation')[0]?.type,
      layoutName: route.meta.layout,
      alreadyRetried: hasRetried(),
    })

    if (!shouldRetry) {
      return
    }

    retryWhenVisible()
  })
})

function hasRetried() {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === '1'
  } catch {
    return false
  }
}

function markRetried() {
  try {
    sessionStorage.setItem(STORAGE_KEY, '1')
  } catch {
    // The `navigate` commit-type gate still prevents reload loops.
  }
}

// A tab committed while hidden (preloaded/background open) could race the
// opening animation again — retry only once the tab is actually visible.
function retryWhenVisible() {
  if (document.visibilityState === 'visible') {
    return retryCommit()
  }

  document.addEventListener('visibilitychange', () => retryCommit(), { once: true })
}

function retryCommit() {
  markRetried()
  window.location.reload()
}
